
export default function AboutUs() {
  return (
    <section id="ueber-uns" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="bg-[#1A2B4A] rounded-3xl p-8 sm:p-12 md:p-16 flex flex-col justify-center shadow-xl">
          <div className="mb-4 sm:mb-6">
            <i className="ri-double-quotes-l text-[#F4B942] text-4xl sm:text-5xl opacity-50"></i>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6 sm:mb-8">
            Qualität & Vertrauen seit 2013
          </h2>

          <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-6 sm:mb-8">
            <p className="text-base sm:text-lg text-white leading-relaxed" style={{ lineHeight: '1.8' }}>
              Elektro Tomasevic KG wurde 2013 in Wien gegründet. Wir stehen für persönliche Beratung, präzise Planung und höchste Qualität bei allen Elektroarbeiten. Unser Team aus erfahrenen Fachkräften betreut Sie von der ersten Idee bis zur finalen Abnahme.
            </p>

            <p className="text-base sm:text-lg text-white leading-relaxed" style={{ lineHeight: '1.8' }}>
              Mit über 10 Jahren Erfahrung im Bereich Elektroinstallationen, Photovoltaik und Sicherheitstechnik sind wir Ihr verlässlicher Partner in Wien. Wir legen großen Wert auf Sicherheit, Effizienz und Kundenzufriedenheit.
            </p>
          </div>

          <p className="text-[#F4B942] text-base sm:text-lg font-serif italic mb-6 sm:mb-8">
            Ihr Elektro Tomasevic
          </p>

          <div>
            <a
              href="#kontakt"
              className="inline-block bg-[#F4B942] text-[#1A2B4A] px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:bg-[#e5a832] transition-all duration-300 hover:shadow-xl whitespace-nowrap"
            >
              Kontakt aufnehmen
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
